import Field from "@/includes/fields/Field";
import slugify from "slugify";

export type LikertInstructions = [string?, string?]

export type LikertOptions = [string?, string?]

export type LikertResult = [string, string]

export default class LikertField extends Field {

    instructions: Array<LikertInstructions>
    options: Array<LikertOptions>

    constructor(label: string, instructions: Array<string>, options: Array<string>) {
        super(label, '')
        this.instructions = instructions.map(instruction => [instruction, slugify(instruction).toLowerCase()])
        this.options = options.map(option => [option, slugify(option).toLowerCase()])
    }

    clear = (): Field => {
        super.setValue(null)
        return this;
    };

    isEmpty(): boolean {
        return this.getValue() && 0 === Object.keys(this.getValue()).length
    }

    getType = (): string => "likert"

    setValue(value?: any) {
        let oldValues;
        if(Array.isArray(value)) {
            oldValues = this.getValue() || {}
            oldValues[value[0]] = value[1]
        } else {
            oldValues = value
        }
        super.setValue(oldValues)
    }

}